// extracted by mini-css-extract-plugin
module.exports =  {"close":"_0d624b9a27--close--v38Z9"};